import { createFileRoute } from '@tanstack/react-router';
import ObjectTypePage from '@/pages/workspaces/objects/object-type.page';
import { ObjectsRoute } from '@/pages/workspaces/objects/routing';
import { RumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/')({
  component: () => (
    <ObjectsRoute>
      <RumPageRendered>
        <ObjectTypePage />
      </RumPageRendered>
    </ObjectsRoute>
  ),
});
